module.exports = __webpack_public_path__ + "static/media/digital_thought_of_the_year.7adb8b5b.jpeg";